export const config = {
    environment: 'prod',

    // PROD Backend URL
    apiUrl: 'https://odm-portal-backend-c2b8gehtamasfrdg.germanywestcentral-01.azurewebsites.net',

    // Azure AD Authentication (TEMPORARILY USING UAT VALUES - UPDATE LATER)
    azureClientId: '987c59bd-28f8-4044-9533-2c797df27ec5',
    azureTenantId: '6e06e42d-6925-47c6-b9e7-9581c7ca302a',
    msalRedirectUri: 'https://odm.allianz.com',

    // Azure AD Security Groups (PROD)
    adminGroupId: 'ac48d0ac-c845-4d2b-aa9d-4214a0e0681c',        // ODM-PROD-ADMIN
    requestorGroupId: '9114dd3e-f092-4a8f-ac97-7552a093b2ab',    // ODM-PROD-REQUESTOR

    // GIAM groups: ODM_PM_ASSIGNMENT gates the Assign PM button,
    // ODM_COMMERCIAL_MANAGER gates the Commercial Manager quote-approval panel
    pmAssignmentGroupId: '9291487f-7081-413e-9cc8-55235238a482', // ODM_PM_ASSIGNMENT
    commercialManagerGroupId: 'd15580d7-a0db-42da-862c-895caadc928b' // ODM_COMMERCIAL_MANAGER
};
